import { render, staticRenderFns } from "./RegisterContent.vue?vue&type=template&id=1bad4196&scoped=true&"
import script from "./RegisterContent.vue?vue&type=script&lang=js&"
export * from "./RegisterContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad4196",
  null
  
)

export default component.exports